// extracted by mini-css-extract-plugin
export default {"crossLine":"Compass_crossLine__xHLFj","crossLineX":"Compass_crossLineX__-gcHn","perspectiveBoxCompass":"Compass_perspectiveBoxCompass__mq1v1"};